import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
const path_image = "https://informed.pro/componentAssets/images/"

export function LinkWithTooltip({ id, children, href, tooltip }) {
  return (
    <OverlayTrigger
      overlay={<Tooltip id={id}><div dangerouslySetInnerHTML={{ __html: tooltip }} /></Tooltip>}
      placement="top"
      delayShow={300}
      delayHide={150}
    >
      <a href={href}>{children}</a>
    </OverlayTrigger>
  );
}




export const renderColorPicker = ({
  value = "", // selected color
  onChange = () => {},
  index = 0,
}) => {
  const colorOptions = [
    "#FFBE2C",
    "#FFD880",
    "#00B3A2",
    "#39CABC",
    "#88DFD7",
    "#004A89",
    "#0066BE",
    "#5C9FD8",
    "#6D2483",
    "#8A4E9C",
    "#B995C4",
    "#E45A62",
    "#F58289",
    "#F9B4B8",
  ];

  return (
    <DropdownButton
      title={
        <div
          className="drop-active"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: value || "#ccc",
              border: "1px solid #ccc",
            }}
          ></div>
        </div>
      }
      variant="light"
      align="end"
      className="color-dropdown"
      autoClose={true}
      onSelect={(color) => onChange(index, color, "color")}
    >
      {colorOptions.map((color) => (
        <Dropdown.Item
          key={color}
          eventKey={color}
          style={{
            backgroundColor: color,
            height: "33px",
          }}
        >
          &nbsp;
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};







const renderEditButton = (
  handleEdit,
  value,
  row,
  className = "dlt_btn edit"
) => (
  <Button onClick={(e) => handleEdit(value, row)} className={className}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.15259 12.8329C2.97037 13.0151 2.84302 13.2448 2.78507 13.4959L1.90302 17.3182C1.72646 18.0833 2.41215 18.7689 3.17722 18.5924L6.99946 17.7103C7.25056 17.6524 7.48033 17.525 7.66255 17.3428L18.0346 6.97075C18.8157 6.1897 18.8157 4.92337 18.0346 4.14232L16.3531 2.46079C15.572 1.67974 14.3057 1.67974 13.5247 2.46079L3.15259 12.8329ZM3.52201 16.9734L4.2386 13.8682L12.2063 5.90046L14.5949 8.2891L6.62724 16.2568L3.52201 16.9734ZM15.6556 7.22844L13.267 4.8398L14.5853 3.52145C14.7806 3.32618 15.0972 3.32618 15.2924 3.52145L16.974 5.20298C17.1692 5.39824 17.1692 5.71483 16.974 5.91009L15.6556 7.22844Z"
        fill="#ffffff"
      />
    </svg>
  </Button>
);

const renderDeleteButton = (
  handleDelete,
  value,
  row,
  className = "dlt_btn",
  imageName = "delete.svg"
) => (
  <Button onClick={(e) => handleDelete(value, row)} className={className}>
    <img src={path_image + imageName} alt="delete" width={16} />
  </Button>
);



const renderValues = ({
  handleEdit,
  handleDelete,
  row,
  handleAdd,
  editingRowId,
  handleSaveEditedRow,
  parentId,
  arrowFlag,
  setExpendRowId,
  expandedRowId,
}) => {
  const isEditing = editingRowId === row.id;
  const isNew = typeof row.id === "string" && row.id.startsWith("temp-");
  const type = arrowFlag ? "parent" : "child";
  const deleteBtnClass =
    isEditing && !isNew ? "btn-delete disabled" : "btn-delete";
  return (
    <div className="action-buttons">
      <LinkWithTooltip tooltip="Delete topic">
        {renderDeleteButton(
          handleDelete,
          null,
          row,
          deleteBtnClass,
          "newDelete.svg"
        )}
      </LinkWithTooltip>
      {isEditing ? (
        <Button
          onClick={() => handleSaveEditedRow(row, type, parentId)}
          className="edit rounded-circle"
        >
          <img src={path_image + "tick.svg"} alt="save" width={16} />
        </Button>
      ) : (
        <LinkWithTooltip tooltip="Edit topic">
          {renderEditButton(handleEdit, null, row, "edit")}
        </LinkWithTooltip>
      )}
      {handleAdd && (
        <LinkWithTooltip tooltip="Add new topic">
          <Button
            onClick={() => handleAdd()}
            className={`add${isNew || isEditing ? " disabled" : ""}`}
          >
            <img
              src={path_image + "add-button-blue.svg"}
              alt="add"
              width={16}
            />
          </Button>
        </LinkWithTooltip>
      )}

      {arrowFlag && (
        <Button
          className={`drop${isNew || isEditing ? " disabled" : ""}${
            row?.id == expandedRowId ? " accordian-active" : ""
          }`}
          onClick={() => setExpendRowId()}
        >
          <img src={path_image + "accordian_arrow.svg"} alt="add" width={16} />
        </Button>
      )}
    </div>
  );
};



export const getRDFirstTableColumns = (
  updateVisibility,
  handleDelete,
  options = {},
  handleEdit,
  handleAddRow,
  editingRowId,
  handleChange,
  handleSaveEditedRow,
  setExpandedRowId,
  expandedRowId,
  editingInputRef,
  errorFlag
) => [
  {
    key: "position",
    label: "",
    render: (value, row) => (
      <>
        <span className="drag-icon">
          <img src={path_image + "drag-img.svg"} alt="drag" width={10} />
        </span>
      </>
    ),
  },
  {
    key: "product",
    label: "Groups",
    render: (value, row) =>
      editingRowId === row.id ? (
        <input
          ref={editingInputRef}
          style={{ backgroundColor: "rgba(0, 102, 190, 0.08)" }}
          className={errorFlag ? "edit-row error" : "edit-row"}
          type="text"
          value={row.product}
          onChange={(e) =>
            handleChange(row.id, "product", e.target.value, "parent")
          }
        />
      ) : (
        row.product
      ),
  },
  {
    key: "color",
    label: "Colour",
    render: (value, row, index) =>
      editingRowId === row.id ? (
        renderColorPicker({
          value: row.product_color,
          defaultColor: "#004A89",
          onChange: (_index, newColor) =>
            handleChange(row.id, "product_color", newColor, "parent"),
          index,
        })
      ) : (
        <div className="drop">
          <div
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: row.product_color || "#ccc",
              borderRadius: "50%",
            }}
          />
        </div>
      ),
  },
  {
    key: "Actions",
    label: "",
    render: (_value, row, index) =>
      renderValues({
        handleEdit,
        handleDelete: (_v, _r) => handleDelete(_v, row, "parent"),
        row,
        handleAdd: () => handleAddRow(index, "parent"),
        editingRowId,
        handleSaveEditedRow,
        parentId: 0,
        arrowFlag: true,
        setExpendRowId: () =>
          setExpandedRowId((prev) => (prev === row.id ? null : row.id)),
        expandedRowId,
      }),
  },
];

export const getRDSecondTableColumns = (
  updateVisibility,
  handleDelete,
  options = {},
  handleEdit,
  handleAddRow,
  editingRowId,
  handleChange,
  handleSaveEditedRow,
  type,
  errorFlag,
  editingInputRef,
  parentId
) => [
  {
    key: "position",
    label: "",
    render: (value, row) => (
      <>
        <span className="drag-icon">
          <img src={path_image + "drag-img.svg"} alt="drag" width={10} />
        </span>
      </>
    ),
  },
  {
    key: "product",
    label: "Topics",
    render: (value, row) =>
      editingRowId === row.id ? (
        <input
          ref={editingInputRef}
          style={{ backgroundColor: "rgba(0, 102, 190, 0.08)" }}
          className={errorFlag ? "edit-row error" : "edit-row"}
          type="text"
          value={row.product}
          onChange={(e) =>
            handleChange(row.id, "product", e.target.value, "child", parentId)
          }
        />
      ) : (
        row.product
      ),
  },
  ...(type === "topics"
    ? [
        {
          key: "color",
          label: "Colour",
          render: (value, row, index) =>
            editingRowId === row.id ? (
              renderColorPicker({
                value: row.product_color,
                defaultColor: "#004A89",
                onChange: (_index, newColor) =>
                  handleChange(
                    row.id,
                    "product_color",
                    newColor,
                    "child",
                    parentId
                  ),
                index,
              })
            ) : (
              <div className="drop">
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: row.product_color || "#ccc",
                    borderRadius: "50%",
                  }}
                />
              </div>
            ),
        },
      ]
    : []),
  {
    key: "Actions",
    label: "",
    render: (_value, row, index) =>
      renderValues({
        handleEdit,
        handleDelete: (_v, _r) => handleDelete(_v, row, "child", parentId),
        row,
        handleAdd: () => handleAddRow(index, "child", parentId),
        editingRowId,
        handleSaveEditedRow,
        parentId: parentId,
        arrowFlag: false,
      }),
  },
];
